import clsx from 'clsx'
import { useState } from 'react'
import { IVerifyCodeProps } from './types'
import styles from './styles.module.scss'

const VerifyCode = ({
  autoFocus,
  disabled,
  id,
  length,
  label,
  onComplete,
  onBlur,
  onChange,
  onFocus,
  style,
  ...props
}: IVerifyCodeProps) => {
  const array: { id: number; value: number | undefined }[] = Array.from({ length }, (_, index) => ({
    id: index,
    value: undefined,
  }))
  const [state, setState] = useState(array)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget
    const valueAsNumber = Number(value)

    if (value.length === length) {
      onComplete(valueAsNumber)
    }

    setState((prevState) => {
      const updatedState = prevState.map((item, index) => {
        if (index < value.length) {
          return { ...item, value: Number(value[index]) }
        }
        return { ...item, value: undefined } // Set to undefined if value is shortened
      })
      return updatedState
    })

    onChange?.(event)
  }

  return (
    <label
      className={clsx('mui-verify-code', 'body-18-medium', styles.label)}
      data-testid="mui-verify-code"
      style={{ ...style }}
      {...props}
    >
      {label && <span className={styles.text}>{label}</span>}
      <input
        autoComplete="off"
        autoFocus={autoFocus}
        className={styles.input}
        disabled={disabled}
        id={id}
        maxLength={length}
        onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur?.(event)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event)}
        onFocus={(event: React.FocusEvent<HTMLInputElement>) => onFocus?.(event)}
        type="tel"
      />
      <div className={styles.wrap} data-style="wrap" role="group" tabIndex={0}>
        {state.map((item) => (
          <div className={clsx('body-16-regular', styles.box)} data-style="box" key={item.id}>
            {item.value ? String(item.value) : 'X'}
          </div>
        ))}
      </div>
    </label>
  )
}

export default VerifyCode
